// Web Notifications API のユーティリティ

/**
 * Notification APIがこのブラウザでサポートされているか確認する
 */
export function isNotificationSupported(): boolean {
	return typeof window !== "undefined" && "Notification" in window;
}

/**
 * 現在の通知許可状態を確認する
 */
export function isNotificationGranted(): boolean {
	const supported = isNotificationSupported();
	const permission = supported ? Notification.permission : "unsupported";
	console.log(
		"[Notification Debug] isNotificationGranted() called. Supported:",
		supported,
		"Permission:",
		permission,
	);
	return supported && Notification.permission === "granted";
}

/**
 * 通知の許可をユーザーにリクエストする
 */
export async function requestNotificationPermission(): Promise<NotificationPermission> {
	if (!isNotificationSupported()) {
		return "denied";
	}
	return await Notification.requestPermission();
}

/**
 * ブラウザ通知を送信する（許可済みの場合のみ）
 */
export function sendNotification(title: string, body: string): void {
	console.log(
		"[Notification Debug] sendNotification() called with title:",
		title,
	);
	if (!isNotificationGranted()) {
		console.warn(
			"[Notification Debug] Notification not sent: Permission not granted.",
		);
		return;
	}
	console.log("[Notification Debug] Creating Notification object...");
	// タイトルと本文で通知を作成し、クリックでフォーカスを戻す
	const notification = new Notification(title, {
		body,
		icon: "/favicon.ico",
	});
	notification.onclick = () => {
		window.focus();
		notification.close();
	};
}
